<script>
    import { url } from '@sveltech/routify'

    let services = [
        {img: '/img/Zuhany.jpg', title: 'Zuhany kabin', link: '/gallery/zuhany'},
        {img: '/img/Dekor.jpg', title: 'Dekor üvegek', link: '/gallery/dekor'},
        {img: '/img/Fal.jpg', title: 'Üvegfal', link: '/gallery/fal'},
        {img: '/img/Ajto.jpg', title: 'Üveg ajtó', link: '/gallery/ajto'},
        {img: '/img/Korlat.jpg', title: 'Üveg korlát', link: '/gallery/korlat'},
        {img: '/img/Egyeb.jpg', title: 'Egyéb munkáink', link: '/gallery/egyeb'},
    ]
    </script>

<div class="pt-10 grid item grid-cols-2 gap-6 md:grid-cols-3 lg:grid-cols-3">
    {#each services as service}
    <a href={$url(service.link)}>
        <div class="flex flex-col items-center pb-10">
            <img src={service.img} alt={service.title}>
            <h1 class="font-bold py-5">{service.title}</h1>
        </div>
    </a>
    {/each}
    </div>